import React from "react";
import Image from "components/image";
import { Swiper, SwiperSlide } from "components/swiper";
import { Mousewheel } from "swiper";
import Button from "components/button";
import RichText from "components/rich-text";

const settings = {
	modules: [Mousewheel],
	slidesPerView: 2.2,
	preventClicks: true,
	preventClicksPropagation: false,
	spaceBetween: 10,
	breakpoints: { 720: { slidesPerView: 4 } },
	mousewheel: {
		enabled: true,
		forceToAxis: true,
	},
	slidesPerGroup: 1,
};

const SliderHero = ({ data }) => (
	<div>
		<div className="text-center mt-5 px-2 md:px-0">
			{data?.content && <div className="mt-8"><RichText value={data?.content} /></div>}

			<Button data={data?.cta} className="relative my-3" />
		</div>
		<div className="flex justify-between">
			<Swiper {...settings}>
				{data?.images?.map((image) => (
					<SwiperSlide key={image._key}>
						<Image image={image} to={image?.url} />
					</SwiperSlide>
				))}
			</Swiper>
		</div>
	</div>
);

export default SliderHero;
